// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type LotSequenceSheetPdfQueryVariables = Types.Exact<{
  developmentId: Types.Scalars['ID']['input'];
  filter: Types.ProjectReadyPlanConfigFilter;
}>;


export type LotSequenceSheetPdfQuery = { __typename?: 'Query', projectReadyPlanConfigs: Array<{ __typename?: 'ProjectReadyPlanConfig', id: string, constructionStartDate?: Types.Scalars['Date']['input'] | null | undefined, project:
      | { __typename?: 'StandaloneProject', id: string, buildAddress: { __typename?: 'Address', id: string, street1: string }, cohort?: { __typename?: 'Cohort', id: string, name: string } | null | undefined }
      | { __typename?: 'Region', id: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined, cohort?: { __typename?: 'Cohort', id: string, name: string } | null | undefined }
      | { __typename?: 'Market', id: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined, cohort?: { __typename?: 'Cohort', id: string, name: string } | null | undefined }
      | { __typename?: 'Community', id: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined, cohort?: { __typename?: 'Cohort', id: string, name: string } | null | undefined }
      | { __typename?: 'Subdivision', id: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined, cohort?: { __typename?: 'Cohort', id: string, name: string } | null | undefined }
      | { __typename?: 'Lot', id: string, buildAddress: { __typename?: 'Address', id: string, street1: string }, cohort?: { __typename?: 'Cohort', id: string, name: string } | null | undefined }
      | { __typename?: 'Structure', id: string, buildAddress: { __typename?: 'Address', id: string, street1: string }, cohort?: { __typename?: 'Cohort', id: string, name: string } | null | undefined }
      | { __typename?: 'Unit', id: string, buildAddress: { __typename?: 'Address', id: string, street1: string }, cohort?: { __typename?: 'Cohort', id: string, name: string } | null | undefined }
    , specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, name: string } } | null | undefined, orientationDetail: { __typename?: 'ProjectReadyPlanConfigOrientationDetail', code: Types.ProjectReadyPlanConfigOrientation, name: string }, readyPlan?:
      | { __typename?: 'ReadyPlan', displayCode?: string | null | undefined, id: string, name: string }
      | { __typename?: 'PlanPackage', displayCode?: string | null | undefined, id: string, name: string }
      | { __typename?: 'DesignPackage', displayCode?: string | null | undefined, id: string, name: string }
      | { __typename?: 'ProductOffering', displayCode?: string | null | undefined, id: string, name: string }
     | null | undefined, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', code: string, id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, isExteriorPalette: boolean, isSpecLevel: boolean }, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }> }>, development: { __typename?: 'Development', id: string, name: string } };

export type PrpcForLotSequenceExportFragment = { __typename?: 'ProjectReadyPlanConfig', id: string, constructionStartDate?: Types.Scalars['Date']['input'] | null | undefined, project:
    | { __typename?: 'StandaloneProject', id: string, buildAddress: { __typename?: 'Address', id: string, street1: string }, cohort?: { __typename?: 'Cohort', id: string, name: string } | null | undefined }
    | { __typename?: 'Region', id: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined, cohort?: { __typename?: 'Cohort', id: string, name: string } | null | undefined }
    | { __typename?: 'Market', id: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined, cohort?: { __typename?: 'Cohort', id: string, name: string } | null | undefined }
    | { __typename?: 'Community', id: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined, cohort?: { __typename?: 'Cohort', id: string, name: string } | null | undefined }
    | { __typename?: 'Subdivision', id: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined, cohort?: { __typename?: 'Cohort', id: string, name: string } | null | undefined }
    | { __typename?: 'Lot', id: string, buildAddress: { __typename?: 'Address', id: string, street1: string }, cohort?: { __typename?: 'Cohort', id: string, name: string } | null | undefined }
    | { __typename?: 'Structure', id: string, buildAddress: { __typename?: 'Address', id: string, street1: string }, cohort?: { __typename?: 'Cohort', id: string, name: string } | null | undefined }
    | { __typename?: 'Unit', id: string, buildAddress: { __typename?: 'Address', id: string, street1: string }, cohort?: { __typename?: 'Cohort', id: string, name: string } | null | undefined }
  , specOption?: { __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, name: string } } | null | undefined, orientationDetail: { __typename?: 'ProjectReadyPlanConfigOrientationDetail', code: Types.ProjectReadyPlanConfigOrientation, name: string }, readyPlan?:
    | { __typename?: 'ReadyPlan', displayCode?: string | null | undefined, id: string, name: string }
    | { __typename?: 'PlanPackage', displayCode?: string | null | undefined, id: string, name: string }
    | { __typename?: 'DesignPackage', displayCode?: string | null | undefined, id: string, name: string }
    | { __typename?: 'ProductOffering', displayCode?: string | null | undefined, id: string, name: string }
   | null | undefined, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', code: string, id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, isExteriorPalette: boolean, isSpecLevel: boolean }, globalOption: { __typename?: 'GlobalOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }> };

export const PrpcForLotSequenceExportFragmentDoc = gql`
    fragment PrpcForLotSequenceExport on ProjectReadyPlanConfig {
  id
  constructionStartDate
  project {
    id
    buildAddress {
      id
      street1
    }
    cohort {
      ...Named
    }
  }
  specOption {
    id
    readyPlanOption {
      ...Named
    }
  }
  orientationDetail {
    code
    name
  }
  readyPlan {
    ...Named
    displayCode
  }
  options {
    id
    readyPlanOption {
      ...Named
      code
      type {
        id
        isElevation
        isExteriorPalette
        isSpecLevel
      }
      globalOption {
        id
        type {
          ...Named
        }
      }
    }
  }
}
    ${NamedFragmentDoc}`;
export const LotSequenceSheetPdfDocument = gql`
    query LotSequenceSheetPdf($developmentId: ID!, $filter: ProjectReadyPlanConfigFilter!) {
  projectReadyPlanConfigs(filter: $filter) {
    ...PrpcForLotSequenceExport
  }
  development(id: $developmentId) {
    id
    name
  }
}
    ${PrpcForLotSequenceExportFragmentDoc}`;

/**
 * __useLotSequenceSheetPdfQuery__
 *
 * To run a query within a React component, call `useLotSequenceSheetPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotSequenceSheetPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotSequenceSheetPdfQuery({
 *   variables: {
 *      developmentId: // value for 'developmentId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useLotSequenceSheetPdfQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LotSequenceSheetPdfQuery, LotSequenceSheetPdfQueryVariables> & ({ variables: LotSequenceSheetPdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LotSequenceSheetPdfQuery, LotSequenceSheetPdfQueryVariables>(LotSequenceSheetPdfDocument, options);
      }
export function useLotSequenceSheetPdfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LotSequenceSheetPdfQuery, LotSequenceSheetPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LotSequenceSheetPdfQuery, LotSequenceSheetPdfQueryVariables>(LotSequenceSheetPdfDocument, options);
        }
// @ts-ignore
export function useLotSequenceSheetPdfSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LotSequenceSheetPdfQuery, LotSequenceSheetPdfQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LotSequenceSheetPdfQuery, LotSequenceSheetPdfQueryVariables>;
export function useLotSequenceSheetPdfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LotSequenceSheetPdfQuery, LotSequenceSheetPdfQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LotSequenceSheetPdfQuery | undefined, LotSequenceSheetPdfQueryVariables>;
export function useLotSequenceSheetPdfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LotSequenceSheetPdfQuery, LotSequenceSheetPdfQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LotSequenceSheetPdfQuery, LotSequenceSheetPdfQueryVariables>(LotSequenceSheetPdfDocument, options);
        }
export type LotSequenceSheetPdfQueryHookResult = ReturnType<typeof useLotSequenceSheetPdfQuery>;
export type LotSequenceSheetPdfLazyQueryHookResult = ReturnType<typeof useLotSequenceSheetPdfLazyQuery>;
export type LotSequenceSheetPdfSuspenseQueryHookResult = ReturnType<typeof useLotSequenceSheetPdfSuspenseQuery>;
export type LotSequenceSheetPdfQueryResult = Apollo.QueryResult<LotSequenceSheetPdfQuery, LotSequenceSheetPdfQueryVariables>;